import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { HabilitarEnvioFacturasComponent } from './HabilitarEnvioFacturas.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';
import { MatDialogModule } from '@angular/material';


const routes = [
    {
        path     : 'HabilitarEnvioFacturas',
        component: HabilitarEnvioFacturasComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'HabilitarEnvioFacturas',
          nombreFormulario : 'HabilitarEnvioFacturas'
        } 
    }
];

@NgModule({
    declarations: [
        HabilitarEnvioFacturasComponent
    ],
    imports     : [
        SharedModule,
        MatDialogModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        HabilitarEnvioFacturasComponent
    ]
})

export class HabilitarEnvioFacturasModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/HabilitarEnvioFacturas/HabilitarEnvioFacturas.module.ts